<script setup lang="ts">
  import { computed } from 'vue';
  import checkPlainObject from '@/common/utils/checkPlainObject';

  const props = withDefaults(defineProps<{
    details: object | string | string[] | object[]
  }>(), {
    details: () => ([])
  });

  const isDetailsInObject = computed(() => checkPlainObject(props.details) && Object.keys(props.details).length > 0);
</script>

<template>
<div data-component-name="recursive-info-detail">
  <template v-if="Array.isArray(details) && details.length > 0">
    <ul v-if="details.length > 1">
      <li
        v-for="(item, index) in details"
        :key="index"
      >
        <recursive-info-detail data-component-name="recursive-info-detail" :details="item" />
      </li>
    </ul>
    <div v-else-if="details.length === 1 && details[0]">
      <recursive-info-detail data-component-name="recursive-info-detail" :details="details[0]" />
    </div>
  </template>
  <template v-else-if="isDetailsInObject">
    <ul v-if="Object.keys(details).length > 1">
      <li
        v-for="(value, key) in details"
        :key="key"
      >
        {{ key }}
        <recursive-info-detail data-component-name="recursive-info-detail" :details="value" />
      </li>
    </ul>
    <div v-else-if="details && Object.keys(details).length === 1">
      <strong>{{ Object.keys(details)[0] }}</strong>
      <recursive-info-detail data-component-name="recursive-info-detail"
        class="ml-16"
        :details="Object.values(details)[0]"
      />
    </div>
  </template>
  <template v-else>
    {{ details }}
  </template>
</div>
</template>

<style scoped lang="scss">
  ul {
    margin: 0;
    padding-inline-start: 24px;
  }
</style>
